export const baseUrl = process.env.REACT_APP_MINDENGAGE_COURSEGEN_API;